import { toast } from "react-toastify"

import api from "@/services/api"
import apiEndPoints from "@/consts/apiEndPoints"

/**
 *
 * @param {{ duplicateId: string, duplicateOrder: string, duplicateSeries: string, companyId: number, customerId: string }} config
 */
export async function downloadPaymentSlip(config) {
  try {
    const response = await api.post(
      apiEndPoints.services.downloadPaymentSlip,
      {
        duplicate_id: config.duplicateId,
        duplicate_order: config.duplicateOrder,
        duplicate_series: config.duplicateSeries,
        company_id: config.companyId,
        customer_id: config.customerId,
      },
      { responseType: "blob" }
    )

    const blob = new Blob([response.data], { type: "application/pdf" })
    const blobUrl = URL.createObjectURL(blob)

    window.open(blobUrl, "_blank")
    // toast.success('Download concluído')
  } catch (error) {
    if (error.isAxiosError) {
      const blobData = error?.response?.data

      if (blobData instanceof Blob) {
        const reader = new FileReader()

        reader.onload = () => {
          try {
            const json = JSON.parse(reader.result)
            toast.error(json.message || "Não foi possível fazer o download")
          } catch {
            toast.error("Erro inesperado ao processar a resposta do servidor.")
          }
        }

        reader.readAsText(blobData)
      }
    }
  }
}
